import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconEyeOff32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconEyeOff32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="m7.832 22.743 1.417-1.417 2.335-2.335 1.062-1.062 5.264-5.264 1.095-1.095 2.105-2.105 1.448-1.448 1.21-1.21a1 1 0 1 1 1.415 1.414l-1.027 1.027c2.211 1.955 3.629 4.32 4.323 5.667a2.34 2.34 0 0 1 0 2.161c-1.333 2.585-5.326 8.915-12.485 8.915-2.596 0-4.776-.833-6.564-2.017l-1.21 1.21a1 1 0 1 1-1.414-1.414zm3.046-.217c1.448.886 3.144 1.465 5.116 1.465 2.938 0 5.264-1.286 7.07-2.956 1.823-1.687 3.027-3.692 3.637-4.875a.34.34 0 0 0 0-.329c-.61-1.183-1.814-3.188-3.638-4.875a14 14 0 0 0-.324-.29l-2.215 2.214a5.498 5.498 0 0 1-7.646 7.646zm3.452-3.453q.353.192.759.301a3.498 3.498 0 0 0 3.983-5.042zM15.994 8a9.5 9.5 0 0 1 3.205.548l1.537-1.537A11.5 11.5 0 0 0 15.994 6C8.836 6 4.842 12.33 3.509 14.915a2.34 2.34 0 0 0 0 2.161 21 21 0 0 0 2.908 4.254l1.416-1.417a19 19 0 0 1-2.546-3.753.34.34 0 0 1 0-.329c.61-1.183 1.814-3.188 3.638-4.875C10.73 9.286 13.055 8 15.994 8"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconEyeOff32);
